import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"
import {
  getServiceLists,
  getServiceList,
  createServiceList,
  updateServiceList,
  deleteServiceList,
} from "api/serviceListApi"

export const SERVICE_LIST_QUERY_KEY = "service-lists"

export const useServiceLists = (params, enabled) =>
  usePaginatedResource(SERVICE_LIST_QUERY_KEY, getServiceLists, params, enabled)

export const useServiceList = (id) =>
  useResourceItem(SERVICE_LIST_QUERY_KEY, getServiceList, id)

export const useCreateServiceList = () =>
  useCreateResource(createServiceList, SERVICE_LIST_QUERY_KEY)

export const useEditServiceList = () =>
  useEditResource(updateServiceList, SERVICE_LIST_QUERY_KEY)

export const useDeleteServiceList = () =>
  useDeleteResource(deleteServiceList, SERVICE_LIST_QUERY_KEY)
